import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { CheckCircle2, Loader2, ArrowRight } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setInfo(data); setStatus("paid"); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setStatus("error"); return; }
        if (tries++ < 15) setTimeout(poll, 2000); else setStatus("timeout");
      } catch { setStatus("error"); }
    };
    poll();
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-950 to-indigo-950 px-4">
      <div className="w-full max-w-lg rounded-2xl bg-white p-8 text-center shadow-2xl">
        {status === "checking" && <><Loader2 className="h-10 w-10 text-indigo-600 animate-spin mx-auto" /><p className="mt-4 text-slate-600">Confirming your payment…</p></>}
        {status === "paid" && (
          <>
            <CheckCircle2 className="h-14 w-14 text-emerald-500 mx-auto" />
            <h1 className="font-heading text-2xl font-bold text-slate-900 mt-4" data-testid="payment-success">Payment confirmed</h1>
            <p className="text-slate-500 mt-2">Welcome to <span className="font-semibold">{info?.plan_name}</span>. Your account is being activated and your implementation project has been created automatically.</p>
            <div className="mt-6 rounded-xl bg-slate-50 border border-slate-200 p-4 text-left text-sm text-slate-600 space-y-1">
              <p>✓ Organization & project created</p>
              <p>✓ Onboarding form generated</p>
              <p>✓ Implementation Architect assigned</p>
            </div>
            <Button onClick={() => navigate("/dashboard")} data-testid="go-onboarding-btn" className="w-full h-12 mt-6 rounded-full bg-indigo-600 hover:bg-indigo-700 font-semibold">Log in & Start Onboarding <ArrowRight className="h-4 w-4 ml-2" /></Button>
          </>
        )}
        {(status === "error" || status === "timeout") && (
          <>
            <h1 className="font-heading text-xl font-bold text-slate-900">We're still confirming</h1>
            <p className="text-slate-500 mt-2">If you completed payment, it will appear shortly. You can log in to your dashboard to check status.</p>
            <Button onClick={() => navigate("/dashboard")} className="mt-6 rounded-full bg-indigo-600 hover:bg-indigo-700">Go to Dashboard</Button>
          </>
        )}
      </div>
    </div>
  );
}
